/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fix_Fdc_NoneInputs */

const en_fix_fdc_none = /** @type {(inputs: Fix_Fdc_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No USDA food linked yet.`)
};

const de_fix_fdc_none = /** @type {(inputs: Fix_Fdc_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noch kein USDA-Lebensmittel verknüpft.`)
};

/**
* | output |
* | --- |
* | "No USDA food linked yet." |
*
* @param {Fix_Fdc_NoneInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const fix_fdc_none = /** @type {((inputs?: Fix_Fdc_NoneInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fix_Fdc_NoneInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_fix_fdc_none(inputs)
	return en_fix_fdc_none(inputs)
});